import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import WinLinesProvider from './winLinesProvider';
import { gsap } from 'gsap';
import './style.css';
import eStateTypes from './enums/eStateTypes';
import eBaseEventTypes from 'Engine/enums/eBaseEventTypes';
import './gradientOverlay/GradientTexture';

export default class Main extends FlashLib.MovieClip {
  constructor(data, displayItemData) {
    super(data, displayItemData);

    this.addListeners();
  }

  onGameResized(data) {
    let halfGameWidth = this.backgroundContainer.displayData.width / 2;
    let halfGameHeight = this.backgroundContainer.displayData.height / 2;
    const portraitOffset = 630;
    halfGameHeight -= data.isMobile ? portraitOffset : 0;

    let mainPivotX;
    let mainPivotY;

    if (data.isLandscape) {
      this.slot.anchorDefault();
      this.slot.scale.set(this.slot.displayData.scaleX);
      // this.slot.x = this.slot.displayData.x + 104;
      // this.slot.y = this.slot.displayData.y + 16;
      // this.slot.scale.set(0.925);
      mainPivotX = halfGameWidth + 300;
      mainPivotY = halfGameHeight - 50;
    } else if (data.isPortrait) {
      const shadowOffset = -7;
      this.slot.pivot.x = this.slot.displayData.width / 2 + (this.backgroundContainer.displayData.width / 2 - portraitOffset);
      this.slot.x = this.backgroundContainer.displayData.width / 2 + shadowOffset;
      this.slot.y = 192;
      this.slot.scale.set(0.75);
      mainPivotX = halfGameWidth + 100;
      mainPivotY = halfGameHeight - 50;
    }

    this.pivot.x = mainPivotX;
    this.pivot.y = mainPivotY;
    this.x = mainPivotX;
    this.y = mainPivotY;
  }

  init() {
    this.displayData.x = this.x;
    this.displayData.y = this.y;
    this.winningsController = new WinLinesProvider({ nextWinTimeout: 2000, nextScatterWinTimeout: 3000 });

    this.slot = this.getChildByName('SlotWrapper');
    this.reelsContainer = this.slot.getChildByName('reelsContainer');

    this.freespinsStart = this.getChildByName('freespinsStart');
    this.freespinsEnd = this.getChildByName('freespinsEnd');

    this.backgroundContainer = this.getChildByName('backgroundContainer');
  }

  addListeners() {
    GlobalDispatcher.add('model:linesChanged', this.onLinesChanged, this);
    GlobalDispatcher.add('stateManager.stateChanged', this.onStateChanged, this);
    GlobalDispatcher.add('stateEnd:initState', this.onInitStateEnd, this);
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this.onGameResized,
      this
    );
    GlobalDispatcher.add(eBaseEventTypes.EBET_ANTISIPATOR__START, this.onStartAntisipator, this);
    GlobalDispatcher.add(eBaseEventTypes.EBET_ANTISIPATOR__STOP, this.onStopAntisipator, this);

    // GlobalDispatcher.add('model:getServerData', this.checkForFreeSpins, this);
  }

  onStartAntisipator() {
    gsap.to(this.scale, { x: 1.03, y: 1.03, duration: 2.5 })
  }

  onStopAntisipator() {
    gsap.to(this.scale, { x: 1, y: 1, duration: 0.2 })
  }

  onLinesChanged(data) {
  }

  onInitStateEnd() {
  }

  onStateChanged(data) {
    switch (data.params) {
      case eStateTypes.EST_INIT:
        break;
      case eStateTypes.EST_WAIT_USER_INTERACTION:
        break;
      case eStateTypes.EST_IDLE:
        break;
      case eStateTypes.EST_FREE_SPINS_IN:
        this.freespinsStart.show(this.slot.willShowBonusStartAnimation ? 2000 : 0);
        this.winningsController.reset();
        break;
      case eStateTypes.EST_FREE_SPINS_OUT:
        this.freespinsEnd.show();
        this.winningsController.reset();
        break;
      case eStateTypes.EST_REQUEST_ROLLING:
        this.slot.start();
        this.winningsController.reset();
        break;
      case eStateTypes.EST_STOP_ROLLING:
        this.slot.stop();
        break;
      case eStateTypes.EST_SHOW_WIN:
        this.winningsController.start();
        break;
    }
  }
}
